import { axiosInstance } from '../utils/axiosinstance';

export interface RubricData {
  overview: string;
  evaluation: string;
  updatedAt: string;
}

export interface RubricResponse {
  success: boolean;
  message?: string;
  data?: RubricData;
}

export const rubricApi = {
  // Get rubric content (GET /rubric)
  getRubric: async (): Promise<RubricResponse> => {
    const token = localStorage.getItem('adminToken');
    const response = await axiosInstance.get(
      '/api/v1/rubric',
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  },

  // Update rubric content (PUT /rubric)
  updateRubric: async (overview: string, evaluation: string): Promise<RubricResponse> => {
    const token = localStorage.getItem('adminToken');
    const response = await axiosInstance.put(
      '/api/v1/rubric',
      { overview, evaluation },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  },
};
